import React from "react";
import Lottie from "lottie-react";
import './Loading.css'; 
import windmillAnimation from "./windmill.json"; 
const WindmillLoading: React.FC = () => {
  return (
    <div className="loading-container">
      <Lottie animationData={windmillAnimation} loop={true} className="windmill-animation" />
      <p className="loading-text">Loading <span className="dots">...</span></p>
    </div>
  );
};

export default WindmillLoading;
